(function () {
  if (window.__aboutBlubeinMotion) return;
  window.__aboutBlubeinMotion = true;

  function revealAll(root) {
    root.querySelectorAll('.about-blubein__reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  function init() {
    var roots = document.querySelectorAll('.about-blubein');
    if (!roots.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      roots.forEach(revealAll);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    roots.forEach(function (root) {
      var items = root.querySelectorAll('.about-blubein__reveal');
      items.forEach(function (el, index) {
        if (!el.style.getPropertyValue('--ab-delay')) {
          var group = el.closest('[data-about-stagger]');
          if (group) {
            var siblings = group.querySelectorAll('.about-blubein__reveal');
            var i = Array.prototype.indexOf.call(siblings, el);
            el.style.setProperty('--ab-delay', Math.min(i, 8) * 80 + 'ms');
          } else if (el.classList.contains('about-blubein__reveal--delay-1')) {
            el.style.setProperty('--ab-delay', '120ms');
          } else if (el.classList.contains('about-blubein__reveal--delay-2')) {
            el.style.setProperty('--ab-delay', '220ms');
          } else if (el.classList.contains('about-blubein__reveal--delay-3')) {
            el.style.setProperty('--ab-delay', '320ms');
          } else {
            el.style.setProperty('--ab-delay', Math.min(index, 4) * 60 + 'ms');
          }
        }
        observer.observe(el);
      });

      var media = root.querySelector('.about-hero__media');
      if (media) media.classList.add('is-active');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
